<template>
  <div>
    <label v-if="label">{{ label }}</label>
    <div
      class="select-item"
      onmouseover="this.children[1].classList.add('hover')"
      onmouseleave="this.children[1].classList.remove('hover');this.children[1].classList.remove('pressed')"
      onmousedown="this.children[1].classList.add('pressed')"
      onmouseup="this.children[1].classList.remove('pressed')"
    >
      <select @change="update" :data-qe-id="qeId">
        <option
          v-for="item in options"
          :value="item.value"
          :key="item.value"
          :selected="item.value == value"
          :data-qe-id="`${qeId}-option--${item.value}`"
        >
          {{ item.name }}
        </option>
      </select>
      <div class="select-arrow icf-arrowBottom"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  options: Array<{ name: string; value: string }>
  label?: string
  qeId: string
  value: string
}>()
const emit = defineEmits(['input'])

function update(event: Event) {
  emit('input', (event.target as HTMLInputElement).value)
}
</script>

<style lang="less">
@import '~@npm/@gd/common-styles/lib/color-vars';
@import '~@npm/@gd/common-styles/dist/input';
@import '~@npm/@gd/common-styles/dist/select';
.select-item {
  .select();
}
</style>
